import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { PlatformBusinessesComponent } from './platform-businesses.component'
import { PlatformBusinessesConnectComponent } from './platform-businesses-connect/platform-businesses-connect.component'
import { PlatformBusinessesETaxInvoiceComponent } from './platform-businesses-e-tax-invoice/platform-businesses-e-tax-invoice.component'

const routes: Routes = [
  {
    path: '',
    component: PlatformBusinessesComponent,
  },
  {
    path: 'e-tax-invoice-by-email',
    component: PlatformBusinessesETaxInvoiceComponent,
  },
  {
    path: ':nameUrl',
    component: PlatformBusinessesConnectComponent,
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PlatformBusinessesRoutingModule {}
